import { styled } from '@mui/system';
import InfoIcon from '@mui/icons-material/Info';

export const StyledInfoIcon = styled(InfoIcon)({
  fontSize: 16,
  margin: '0 2px 0 -4px'
});
